import { Component, HostListener, OnInit } from '@angular/core';
import { NgxPermissionsService } from 'ngx-permissions';
import { forkJoin } from 'rxjs';
import { ALL_PERMISSIONS } from 'src/app/core/constants/permissions.config';
import { ModuleAdminEnum } from 'src/app/core/models/interfaces/permission';
import { UserService } from 'src/app/core/services/user.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-admin-layout',
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.component.scss'],
})
export class AdminLayoutComponent implements OnInit {
  smallScreen = 1439;
  isSmallScreen: boolean = false;
  sidebarVisible: boolean = false;
  user: any;
  readonly MODULE_ADMIN = ModuleAdminEnum.SHOP;

  @HostListener('window:resize', ['$event'])
  checkSmallScreen() {
    this.isSmallScreen = window.innerWidth <= this.smallScreen;
  }

  constructor(
    private userService: UserService,
    private ngxPermissionsService: NgxPermissionsService,
  ) {}

  ngOnInit(): void {
    try {
      this.user = JSON.parse(localStorage.getItem('auth') || '{}');
      this.user.avatarURL = `${environment.BE_URL}storage/files/web/${this.user?.avatar_thumbnail_url}.webp`;
    } catch (error) {}

    this.checkSmallScreen();
    this.onCheckPermission();
  }

  onCheckPermission() {
    forkJoin([
      this.userService.getRoles(),
      this.userService.getPermissions(),
    ]).subscribe({
      next: (results) => {
        const [roleRes, permissionRes] = results;
        const permissions = roleRes.data ?? [];
        const isSuperAdmin = permissions.find(
          (permission) => permission.role === 'SUPER_ADMIN',
        );
        const isHavePermission = permissions.find(
          (permission) => permission.type_moderator === this.MODULE_ADMIN,
        );

        if (isSuperAdmin) {
          this.ngxPermissionsService.loadPermissions([...ALL_PERMISSIONS]);
        } else {
          this.ngxPermissionsService.loadPermissions(permissionRes.data);
        }

        if (!isHavePermission && !isSuperAdmin) {
          window.location.href = `${environment.ADMIN_HUB_URL}`;
        }
      },
      error: () => {
        window.location.href = `${environment.ADMIN_HUB_URL}`;
      },
    });
  }
}
